import { ADMIN_ROUTE_NAMES } from 'utils/consts/administrationFilters'
import { OFFERS_ROUTE_NAMES } from 'utils/consts/routes/offers'
import { offersFiltersName } from './keys'

export const NO_RESTRICTIONS = '#NO_RESTRICTIONS'

export const excludedFiltersOnRoute = {
  [OFFERS_ROUTE_NAMES.buyWineOffers]: [
    offersFiltersName.euGITypeFilter,
    offersFiltersName.distributionFilter,
    offersFiltersName.rankFilter,
    offersFiltersName.monocepageFilter,
    offersFiltersName.buyerCompanyCountryFilter,
  ],
  [OFFERS_ROUTE_NAMES.buyWineAnalysis]: [
    offersFiltersName.distributionFilter,
    offersFiltersName.monocepageFilter,
  ],
  [ADMIN_ROUTE_NAMES.adminOffers]: [],
  [ADMIN_ROUTE_NAMES.adminRequests]: [],
  [OFFERS_ROUTE_NAMES.sellWineMyOffers]: [
    offersFiltersName.euGITypeFilter,
    offersFiltersName.onlyFromProducerFilter,
    offersFiltersName.forCompanyOnlyFilter,
    offersFiltersName.rrpFilter,
    offersFiltersName.priceCoefFilter,
    offersFiltersName.rankFilter,
    offersFiltersName.monocepageFilter,
  ],
}
